import { useContext } from 'react';
import { LatestLoanContext } from '@/hooks/providers/useLatestLoanProvider';

const useLatestLoan = () => useContext(LatestLoanContext);

export default useLatestLoan;
